module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_link_image_flow-dd53bb49263e0282e15d09b8c460f01e.jpg";